(function () {
  'use strict';

  if (window.OvoinCollectionCategoryMenuLoaded) return;
  window.OvoinCollectionCategoryMenuLoaded = true;

  function initMenu(menu) {
    if (menu.dataset.categoryMenuReady === 'true') return;
    menu.dataset.categoryMenuReady = 'true';

    var viewport = menu.querySelector('[data-category-menu-viewport]');
    var previous = menu.querySelector('[data-category-menu-previous]');
    var next = menu.querySelector('[data-category-menu-next]');
    if (!viewport || !previous || !next) return;

    function update() {
      var hasOverflow = viewport.scrollWidth > menu.clientWidth + 2;
      menu.classList.toggle('has-overflow', hasOverflow);
      var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      previous.disabled = !hasOverflow || viewport.scrollLeft <= 2;
      next.disabled = !hasOverflow || viewport.scrollLeft >= maxScroll - 2;
    }

    function move(direction) {
      var distance = Math.max(180, Math.round(viewport.clientWidth * 0.7));
      viewport.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }

    previous.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    viewport.addEventListener('scroll', update, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(viewport);
    } else {
      window.addEventListener('resize', update);
    }

    window.requestAnimationFrame(update);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-collection-category-menu]').forEach(initMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
}());
